<template>
  <div>
    <ShowBookingUpsellStep />
  </div>
</template>

<script>
  import ShowBookingUpsellStep from '@/components/Book/show/ShowBookingUpsellStep'

  export default {
    name: 'ShowBookingUpsells',

    components: {
      ShowBookingUpsellStep,
    },

    computed: {
      steps() {
        return this.$store.getters['showBooking/enabledSteps']
      },
    },

    methods: {
      determineStepNumber() {
        let step = this.steps.findIndex(step => step.name == 'upsells')

        if (step === -1) {
          return this.$router.push({ name: this.steps[0].route })
        }

        this.$store.commit('showBooking/setCurrentStep', step + 1)
      }
    },

    mounted() {
      this.determineStepNumber()
    }
  }
</script>
